"use client";

export default function WhatIs() {
  return (
    <section className="bg-white py-20 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-[32px] font-bold text-secondary text-center mb-3">
          Temporary Plywood Board-Up Service
        </h2>
        <p className="text-gray-600 text-center max-w-[720px] mx-auto text-base">
          We secure broken openings with hurricane-grade plywood until permanent repair. Temporary protection only.
        </p>
      </div>
    </section>
  );
}